import { useState, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { PATH_AUTH } from "@app/routes/paths";
import {
  logout,
  selectIsAuthenticated,
  selectLoginDataState,
} from "@app/modules/common";
import { isTokenExpired } from "@app/utils/isTokenExpired";

// ----------------------------------------------------------------------

interface AuthGuardProps {
  children: ReactNode;
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const dispatch = useDispatch();
  const login = useSelector(selectLoginDataState);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (login?.token && isTokenExpired(login?.token)) {
    dispatch(logout());
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

export default AuthGuard;
